import { render, staticRenderFns } from "./wexinPay.vue?vue&type=template&id=d34e072a&"
import script from "./wexinPay.vue?vue&type=script&lang=js&"
export * from "./wexinPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports